<template>
    <el-dialog :visible.sync="show"
        :title="$t('slb.operations.close.name')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        width="30%">
        <p>{{ $t('slb.sentence.closeCustomSetting')}}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelDelete">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureDelete" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {postListenerPrivateConfigApi} from '@/api/lb/listener/actions'
export default {
    name: 'CloseCustomSetting',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        listenerId: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            show: this.dialogVisible
        };
    },
    watch: {
        dialogVisible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:dialogVisible', false);
        },
        cancelDelete() {
            this.handleClose();
        },
        sureDelete() {
            let param = {
                listenerId: this.listenerId,
                personalize: 'off',
                region: this.region
            }
            postListenerPrivateConfigApi(param)
            .then((res) => {
                if (res.data && res.data.success) {
                    this.$emit('closeCustomComplete');
                }
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
            })
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/slb/closeCustomSetting.vue